import React,{ useState, useEffect } from "react";
import { 
    Card,
    Button,
    Drawer
} from 'antd';

import { 
    ExceptionOutlined,
    UnorderedListOutlined,
    PlusCircleOutlined,
    MinusCircleOutlined
} from '@ant-design/icons';

function TVProductCard( { 
    productData,
    handleAddToCart,
    activeProductId,
    addingToCart,
    isLoading,
    setChannelDrawerOpen,
    channelDrawerOpen,
    openChannelDetailsNotification,
    setChannelDrawerServiceName,
    setChannelDrawerChannelMarkup,
    isPlaceholder } ) {
    //console.log("productData: ", productData);

    let loading = ( addingToCart && ( activeProductId == productData.service_id ) ) ? true : false;
    let active = ( activeProductId == productData.service_id ) ? true : false;

    const handleShowChannelDetails = ( channel ) => {
        //console.log( "channel: ", channel );
        openChannelDetailsNotification( 'bottom', channel );
    }

    const handleClickViewMoreButton = ( e ) => {
        //console.log('packagetype: ', e.target.dataset.packagetype);
        setChannelDrawerOpen( true );
        let channelMarkup = getIncludedChannelsMarkup( productData[ 'included_channels' ][ 0 ].length, false );
        setChannelDrawerServiceName( productData['post_title'] );
        setChannelDrawerChannelMarkup( channelMarkup );

    }

    const getIncludedChannelsMarkup = ( channelsToShow, showViewMore ) => {
        let includedChannels = [];
        for( let i=0; i < channelsToShow; i++ ) {
            includedChannels.push(
                <div 
                    className="channel-thumb"
                    onClick={ () => handleShowChannelDetails( productData[ 'included_channels' ][ 0 ][i] ) }
                    >
                    <img src={productData[ 'included_channels' ][ 0 ][i].logo}/>
                </div>
            );
        }

        if( showViewMore ) {
            includedChannels.push( 
                <div 
                    class="view-channels-btn-cta tv-package-channels off-canvas-zf channel-thumb tv-package-channel-thumb-view-more" 
                    role="button" 
                    tabindex="0" 
                    data-packagetype={ productData[ 'product_attributes' ]['tv-package-id']['value'] } 
                    aria-expanded="false" 
                    aria-controls="off-canvas-right"
                    onClick={ handleClickViewMoreButton }>
                    View More
                </div>
            );
        }

        return includedChannels;
    }

    if( isPlaceholder ) {
        return <Card
            className="tv-product-card"
            loading={ true }
            title={ '' } 
            bordered={ active }>
            
            <div className="product-card-content">
                <div className="product-card-detail-container"></div>
            </div>
        </Card>
    } else {
        let reccomendedClass = ( productData.service_id == 1978 ) ? 'recommended' : '';

        return (
            <Card
                className={ `product-card ${ reccomendedClass } tv-product-card` }
                loading={ isLoading }
                hoverable
                title={
                    <div className="product-title-container">
                        <div className="product-title">
                            { productData['post_title'] }
                            <Button
                                type="text"
                                onClick={ handleClickViewMoreButton }
                                icon={ ( channelDrawerOpen ) ? <MinusCircleOutlined /> : <PlusCircleOutlined />}
                            >View more</Button>
                        </div>
                    </div>
                } 
                bordered={ active }
            >
            
                <div className="product-card-content">
                    <div className="product-card-detail-container">
                        <p>{productData['post_description']}</p>
                        <div className="product-card-included-channels-container">
                            { getIncludedChannelsMarkup( 17, true ) }
                        </div>
                    </div>
                    <div className="product-card-sidebar-container">
                        <div className="product-price-container">
                            <span className="dolla">$</span>
                            <span className="price">{ productData['service_price'] }</span>
                            <span className="duration">/mo</span>
                        </div>
                        <div className="product-card-detail">
                            <a href="/start-tv-terms-and-conditions" target="_blank" >*Terms and conditions apply</a>
                        </div>
                        <div className="product-card-detail">
                            <UnorderedListOutlined />
                            <span className="product-card-detail-copy">{`${ productData['included_channels'][0].length } channels`}</span>
                        </div>
                        <div className="product-card-detail">
                            <ExceptionOutlined />
                            <span className="product-card-detail-copy">No contract</span>
                        </div>
                        <Button 
                            type="primary" 
                            loading={ loading } 
                            style={{marginTop: '1rem'}}
                            onClick={ () => handleAddToCart( productData.service_id, productData.post_title )}>
                            Select Plan
                        </Button>
                    </div>
                </div>
            </Card>
        )
    }
}

export default TVProductCard